import { Box, Divider, Fade, Grid, Typography } from "@material-ui/core"
import { useStyles } from "./historico-pedidos-list-styles"
import React, { useCallback, useEffect, useState } from "react"
import { useGetMovimento } from "api/movimentacao/get-movimento"
import { VendaResumidoModel } from "models/api/venda/venda-resumido-model"
import { useNotificacoes } from "components/notificacoes"
import { HistoricoPedidoListData } from "./historico-pedidos-list-data"
import { getIDFromUrl } from "utils/get-id-url"
import { usePessoaUsuarioStore } from "services/store/pessoa-usuario"
import { CircularLoading } from "components/utils/circular-loading"
import { useGetPedidosLista } from "api/cardapio/queries/pedidos/get-pedidos"
import { PedidoModel } from "api/cardapio/models/pedido/pedido"
import { PedidosPendentesListData } from "./pedidos-pendentes-list-data"
import { useHistory } from "react-router-dom"
import { useEmpresaAtual } from "services/hooks/empresa"
import { EnumModals, useModalStore } from "services/store/modal-store"

export type HistoricoPedidosListProps = {
    onClick: (id: string) => void
}

export const HistoricoPedidosList = ({ onClick }: HistoricoPedidosListProps) => {
    const classes = useStyles()
    const { openCloseModal } = useModalStore((state) => state)

    const { getMovimento, carregando: carregandoMovimento } = useGetMovimento()
    const { getPedidosLista, carregando: carregandoPedidosLista } = useGetPedidosLista()
    const { showErrorMessage } = useNotificacoes()
    const { pessoa } = usePessoaUsuarioStore()
    const { getEmpresaAtual } = useEmpresaAtual()
    const history = useHistory()

    const carregando = carregandoMovimento || carregandoPedidosLista

    const [queryStatus, setQueryStatus] = useState({
        page: 1,
        totalPages: 0,
        totalResults: 0,
        list: Array<VendaResumidoModel>(),
    });
    const [pedidosPendentes, setPedidosPendentes] = useState<PedidoModel[]>([])

    const fillResult = useCallback(
        async (
            page: number,
            totalPages: number,
            totalResults: number,
            list: Array<VendaResumidoModel>,
        ) => {
            setQueryStatus({
                page: page,
                list: list,
                totalResults: totalResults,
                totalPages: totalPages,
            });
        }, []);

    const search = useCallback(
        async (newPage: number) => {
            try {
                const res = await getMovimento(
                    getIDFromUrl('empresaId') ?? '',
                    pessoa?.id ?? '',
                    newPage,
                );
                if (res.erro) throw res.erro;

                //se o index for maior que as paginas ele busca a ultima
                if (
                    res.resultado?.data?.pageIndex > res.resultado?.data?.totalPages &&
                    res.resultado?.data?.totalResults > 0
                ) {
                    search(newPage);
                    return;
                }

                fillResult(
                    res.resultado?.data?.pageIndex,
                    res.resultado?.data?.totalPages,
                    res.resultado?.data?.totalResults,
                    res.resultado?.data?.list,
                );
            } catch (e: any) {
                showErrorMessage(e.message);
            }
        },
        [getMovimento, pessoa?.id, fillResult, showErrorMessage],
    );

    const searchPedidosPendentes = useCallback(
        async (newPage: number) => {
            try {
                const res = await getPedidosLista(
                    // &status=${EnumStatusPedido.AGUARDANDO_CONFIRMACAO}&status=${EnumStatusPedido.EM_PREPARO}&status=${EnumStatusPedido.ENVIADO}&status=${EnumStatusPedido.CONFIRMADO}
                    `?page=${newPage}`,
                    getIDFromUrl('empresaId') ?? '',

                );
                if (res.erro) throw res.erro;
                const resultado = res.resultado?.data?.list ?? []
                setPedidosPendentes(resultado)
            } catch (err: any) {
                showErrorMessage(err.message);
            }
        }, [getPedidosLista, showErrorMessage])

    useEffect(() => {
        if (pessoa?.id) {
            search(1);
            searchPedidosPendentes(1);
        }
    }, [pessoa?.id, search, searchPedidosPendentes])

    const onClickPedido = (pedidoId: string) => {
        openCloseModal(EnumModals.HistoricoPedidos, false)
        history.push(`/${getEmpresaAtual()?.id ?? ''}/pedido/${pedidoId} `)
    }

    if (carregando) {
        return (
            <Box height="100%" position="relative">
                <CircularLoading tipo="FULLSIZED" titulo="Carregando pedidos..." />
            </Box>
        )
    }


    return (
        <Fade in>
            <Box className={classes.container}>
                {pedidosPendentes.length > 0 && (
                    <Box pb={2}>
                        <Box mb={2}>
                            <Typography variant="h6">
                                Pedido em andamento
                            </Typography>
                        </Box>
                        <Grid container spacing={1}>
                            <PedidosPendentesListData list={pedidosPendentes} onClick={onClickPedido} />
                        </Grid>
                        <Box pt={2}>
                            <Divider />
                        </Box>
                    </Box>
                )}
                <Box>
                    <Box mb={2}>
                        <Typography variant="h6">
                            Pedidos finalizados
                        </Typography>
                    </Box>
                </Box>
                <Grid container spacing={1} className={classes.grid}>
                    <HistoricoPedidoListData list={queryStatus.list} onClick={onClick} carregando={carregando} />
                </Grid>
            </Box>
        </Fade>
    )
}